export default __webpack_public_path__ + "static/char-s-53-ja-11202653316584d5a15ef1c3e5a79326.webp";